<template>
  <div class="documents-wrapper">
    <div class="sticky-header">
      <a-tabs type="card" v-model="activeTab" @change="handleTabChange" class="tab-header">
        <a-tab-pane key="regulations" tab="Regulations" />
        <a-tab-pane key="announcement" tab="Announcement" />
        <a-tab-pane key="form" tab="Form" />
      </a-tabs>

      <div class="search-wrapper">
        <a-input-search
          size="small"
          placeholder="ค้นหาชื่อเอกสาร..."
          v-model="searchText"
          class="search-input"
          allow-clear
        />
      </div>
    </div>

    <a-list
      class="doc-list"
      :loading="loading"
      item-layout="horizontal"
      :data-source="filteredDataList"
      :pagination="false"
    >
      <a-list-item slot="renderItem" slot-scope="item">
        <template slot="actions">
          <a class="font-weight-bold" target="_blank" :href="item.doc_file"><a-icon
              type="download" :style="{ fontSize: '24px', color: '#47B5FF' }" /></a>
        </template>
        <a-list-item-meta>
          <template slot="title">
            <span class="font-weight-bold">{{ item.file_name }}</span>
          </template>
          <template slot="description">
            <div class="mt-5">
              <a-tag :color="item.status === 'active' ? 'green' : 'orange'" size="small">
                {{ item.status }}
              </a-tag>
              <span class="text-muted ml-10">
                <a-icon type="clock-circle" class="mr-5" />
                เอกสารอัพเดทเมื่อ: {{ moment(item.updated_at).add(543, 'year').locale('th').format('D MMMM YYYY') }} เวลา {{ moment(item.updated_at).format('HH:mm') }} น.
              </span>
            </div>
          </template>
          <a-avatar
            slot="avatar"
            :icon="getIconByDocType(item.doc_type)"
            :style="{ backgroundColor: getIconColorByDocType(item.doc_type) }"
          />
        </a-list-item-meta>
      </a-list-item>
    </a-list>
  </div>
</template>

<script>
import moment from "moment";

export default {
  data() {
    return {
      activeTab: 'regulations',
      dataList: [],
      loading: false,
      moment,
      searchText: "",
    };
  },
  computed: {
    filteredDataList() {
      const hiddenPatterns = ['_[AcademicStaff]', '_[SupportStaff]_E', '_[SupportStaff]_T', '_WF_', '_GI_', '_CS_', '_DV_', '_DW_'];
      
      let result = this.dataList.filter((item) => {
        const matchesSearch = item.file_name.toLowerCase().includes(this.searchText.toLowerCase());
        const isHidden = hiddenPatterns.some(pattern => item.file_name.includes(pattern));
        return matchesSearch && !isHidden;
      });

      if (this.activeTab === 'form') {
        result.sort((a, b) => 
          a.file_name.localeCompare(b.file_name, undefined, { numeric: true, sensitivity: 'base' })
        );
      }

      return result;
    },
  },
  mounted() {
    this.fetchDocuments();
  },
  methods: {
    handleTabChange() {
      this.searchText = "";
      this.fetchDocuments();
    },
    async fetchDocuments() {
      this.loading = true;
      try {
        const res = await this.$http.get(`/hri/doc-file/?doc_type=${this.activeTab}`);
        if (res.status === 200) {
          this.dataList = res.data;
        }
      } catch (error) {
        console.error("Error fetching documents:", error);
        this.$message.error("Failed to load documents");
      } finally {
        this.loading = false;
      }
    },
    getIconByDocType(type) {
      const icons = {
        regulations: "book",
        announcement: "notification",
        form: "file-text",
      };
      return icons[type] || "file";
    },
    getIconColorByDocType(type) {
      const colors = {
        regulations: "#1890ff",
        announcement: "#52c41a",
        form: "#faad14",
      };
      return colors[type] || "#bfbfbf";
    },
  },
};
</script>

<style scoped>
.font-weight-bold {
  font-weight: bold;
}
.sticky-header {
  position: sticky;
  top: -24px;
  z-index: 100;
  background: #ffffff;
  padding: 10px 0;
  margin-top: -24px;
  margin-bottom: 10px;
  border-bottom: 1px solid #f0f0f0;
}
.tab-header {
  margin-top: 10px;
  margin-bottom: 10px !important;
}
.search-wrapper {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 8px;
  padding: 0 16px;
}
.search-input {
  width: 250px;
}
@media screen and (max-width: 576px) {
  .search-wrapper {
    padding: 0 10px;
  }
  .search-input {
    width: 100% !important;
  }
}
.doc-list {
  background: #fff;
  padding: 0 16px;
  border-radius: 8px;
  margin-bottom: 200px;
}
</style>
